var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-layout" }, [
    _c(
      "div",
      { staticClass: "header-section" },
      [
        _vm.gridApi
          ? _c("search-filter-manager", {
              attrs: {
                "grid-api": _vm.gridApi,
                "grid-url": "/api/invoices/team-member/grid/saved",
                "refresh-server-side": _vm.refreshServerSide,
              },
              on: {
                "filter-loaded": _vm.filterHasLoaded,
                onSearch: _vm.handleFilterOrSearch,
              },
            })
          : _vm._e(),
        !_vm.isTeamMember
          ? _c(
              "div",
              { staticClass: "generate-invoice-section" },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "md-primary md-just-icon md-round",
                    attrs: { title: "Generate Invoices" },
                    on: { click: _vm.createInvoice },
                  },
                  [_c("md-icon", [_vm._v("library_add")])],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "page-content" },
      [
        _c("bulk-actions", {
          attrs: {
            "selected-invoices": _vm.selectedRows,
            "trigger-sync-to-accounting-package":
              _vm.triggerSyncToAccountingPackage,
          },
          on: { refresh: _vm.refreshGrid },
        }),
        _c("ag-grid-vue", {
          staticClass: "grid-display",
          class: _vm.gridThemeClass,
          attrs: {
            "row-model-type": "serverSide",
            "column-defs": _vm.columnDefs,
            "default-col-def": _vm.defaultColDef,
            "grid-options": _vm.gridOptions,
            "suppress-excel-export": false,
            "row-selection": _vm.rowSelection,
            "side-bar": _vm.gridSideBar,
          },
          on: {
            "grid-ready": _vm.onGridReady,
            "selection-changed": _vm.onSelectionChanged,
          },
        }),
      ],
      1
    ),
    _vm.showProgressBox
      ? _c("div", { staticClass: "progress-container" }, [
          _c(
            "div",
            { staticClass: "button-close" },
            [
              _c(
                "md-button",
                {
                  staticClass: "md-default md-just-icon md-round",
                  on: { click: _vm.handleCloseProgressBox },
                },
                [_c("md-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
          !_vm.isProgressComplete
            ? _c("div", { staticClass: "progress-text-section" }, [
                _vm._m(0),
                _vm.totalInvoice == 0
                  ? _c("div", [_vm._v("Preparing invoices...")])
                  : _c("div", [
                      _vm._v(
                        _vm._s(_vm.currentProcessedInvoice) +
                          " of " +
                          _vm._s(_vm.totalInvoice) +
                          " invoices have been generated."
                      ),
                    ]),
              ])
            : _c("div", { staticClass: "progress-text-section" }, [
                _c(
                  "div",
                  [
                    _c("md-icon", { staticClass: "green-check" }, [
                      _vm._v("check_circle"),
                    ]),
                  ],
                  1
                ),
                _c("div", [
                  _vm._v(
                    "\n                Process has been completed.\n            "
                  ),
                ]),
              ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("div", { staticClass: "btn-loader route-loader" })])
  },
]
render._withStripped = true

export { render, staticRenderFns }